export default function SharedResolutionSettingsNotice() {
  return (
    <p className="inline-flex items-center rounded-full border border-blue-100 bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-800">
      Applies to returns and exchanges
    </p>
  );
}
